import type { RouteRecordRaw } from 'vue-router'

const DatasetManagementData = () => import('@/modules/Datasets/RouteDatasetManagementData.vue')

const meta = { requiresAuth: true, requiresAbility: 'view_full_datasets' }

const datasetManagementRoute: RouteRecordRaw = {
  path: 'dataset-management',
  component: () => import('@/modules/Datasets/RouteDatasetManagement.vue'),
  children: [
    {
      name: 'DatasetManagementData',
      path: '',
      component: DatasetManagementData,
      meta,
    },
    { path: 'data', redirect: { name: 'DatasetManagementData' }, meta },
    {
      name: 'DatasetManagementFolderData',
      path: 'tree/:path+',
      component: DatasetManagementData,
      meta,
    },
  ],
  meta,
}

const OverviewView = (): unknown => import('@/modules/Datasets/RouteDatasetOverview.vue')
const WorkflowView = (): unknown => import('@/modules/Datasets/RouteDatasetWorkflow.vue')
const DatasetClassesView = (): unknown => import('@/modules/Datasets/RouteDatasetClasses.vue')
const SettingsView = (): unknown => import('@/modules/Datasets/RouteDatasetSettings.vue')

const datasetDetailsRoute: RouteRecordRaw = {
  path: '/datasets/:datasetId',
  component: () => import('@/modules/Datasets/RouteDataset.vue'),
  props: ({ params }) => ({ ...params, datasetId: parseInt(params.datasetId as string) }),
  children: [
    { path: 'workflow', name: 'DatasetWorkflow', component: WorkflowView, meta },
    { path: 'overview', name: 'DatasetOverview', component: OverviewView, meta },
    {
      path: 'classes',
      name: 'DatasetClasses',
      component: DatasetClassesView,
      meta,
      children: [
        {
          path: ':editClassId',
          name: 'DatasetClassesEdit',
          component: DatasetClassesView,
          props: (route) => ({
            datasetId: parseInt(route.params.datasetId as string),
          }),
        },
      ],
      props: (route) => ({
        datasetId: parseInt(route.params.datasetId as string),
      }),
    },
    datasetManagementRoute,
    { path: 'settings', name: 'DatasetSettings', component: SettingsView, meta },
  ],
  meta,
}

export default datasetDetailsRoute
